import { createSelector } from '../reselect';
import { simpleChart2, getNewStatsService, simpleChart, total, safeDivide } from '../generalUtils';

const getNewStats = getNewStatsService('bing');

const bingAdSpend = createSelector([getNewStats], (stats) => {
  return total(stats, 'spend');
});

const bingAdSpendChart = createSelector([getNewStats], (stats) => {
  return simpleChart(stats, 'spend');
});

const bingConversionValue = createSelector([getNewStats], (stats) => {
  return total(stats, 'conversionValue');
});

const bingConversionValueChart = createSelector([getNewStats], (stats) => {
  return simpleChart(stats, 'conversionValue');
});

const bingConversions = createSelector([getNewStats], (stats) => {
  return total(stats, 'conversions');
});

const bingConversionsChart = createSelector([getNewStats], (stats) => {
  return simpleChart(stats, 'conversions');
});

const bingRoas = createSelector(
  [bingConversionValue, bingAdSpend],
  (bingConversionValue, bingAdSpend) => {
    return safeDivide(bingConversionValue, bingAdSpend);
  }
);

const bingRoasChart = createSelector(
  [getNewStats, bingConversionValueChart, bingAdSpendChart],
  (stats, conversionValue, spend) => {
    return simpleChart2(conversionValue, spend);
  }
);

const bingImpressions = createSelector([getNewStats], (stats) => {
  return total(stats, 'impressions');
});

const bingImpressionsChart = createSelector([getNewStats], (stats) => {
  return simpleChart(stats, 'impressions');
});
const bingCpm = createSelector([bingImpressions, bingAdSpend], (impressions, spend) => {
  return safeDivide(spend, impressions / 1000);
});

const bingCpmChart = createSelector(
  [bingImpressionsChart, bingAdSpendChart],
  (impressions, spend) => {
    return simpleChart2(spend, impressions, { chart1yMultiplier: 1000 });
  }
);

const bingClicks = createSelector([getNewStats], (stats) => {
  return total(stats, 'clicks');
});

const bingClicksChart = createSelector([getNewStats], (stats) => {
  return simpleChart(stats, 'clicks');
});

const bingCpa = createSelector(
  [getNewStats, bingAdSpend, bingConversions],
  (stats, spend, purchases) => {
    return safeDivide(spend, purchases);
  }
);

const bingCpaChart = createSelector(
  [getNewStats, bingAdSpendChart, bingConversionsChart],
  (stats, spend, purchases) => {
    return simpleChart2(spend, purchases);
  }
);

const bingCtr = createSelector([bingClicks, bingImpressions], (clicks, impressions) => {
  return safeDivide(clicks, impressions) * 100;
});

const bingCtrChart = createSelector(
  [bingClicksChart, bingImpressionsChart, getNewStats],
  (clicks, impressions) => {
    return simpleChart2(clicks, impressions, { chart1yMultiplier: 100 });
  }
);

const PROPS_TO_SELECTORS = {};

export default {
  PROPS_TO_SELECTORS,
  SELECTORS: {
    bingClicks,
    bingClicksChart,
    bingAdSpend,
    bingAdSpendChart,
    bingConversions,
    bingConversionsChart,
    bingConversionValue,
    bingConversionValueChart,
    bingImpressions,
    bingImpressionsChart,
    bingCpm,
    bingCpmChart,
    bingCpa,
    bingCpaChart,
    bingRoas,
    bingRoasChart,
    bingCtr,
    bingCtrChart,
  },
};
